import ChangePasswordModalContainer from './containers/ChangePasswordModalContainer'

export default ChangePasswordModalContainer
